if (typeof define === "function" && define.amd) {
    define('Controls/DeferredDataMng',[], function () {
        /**
         * Настройки объекта по умолчанию. Создается конструктором
         * @param container
         * @constructor
         */
        function DeferredDataMng(container) {
            this.root = $(container);
            this.items = $();
            this.process = $.Deferred();
            this.pendings = [];
            this.selectors = $();
        }

        //------------------------------------------------------------

        /**
         * копирует разметку-источник в заданные блоки на странице. Источник после этого удаляется.
         * @param item
         * @param toItem
         * @returns {boolean}
         */
        DeferredDataMng.prototype.copy = function (item, toItem) {
            var o = this;
            var toID = item.attr('to');
            if (typeof toID == 'undefined') {
                toID = item.data('to-deffered');
            }

            if (toID.length && toItem.length) {
                try {
                    o.setNewTitle(toItem);
                    o.pendings = o.pendings.slice(0, -1);
                    item.clone(true, true).appendTo(toItem);

                    o.process.resolve();

                    if (o.pendings.length === 0) {
                        o.process.done(function (){
                            //Здесь назначается обработчик после копирования элементов. Удаляем источник
                            if(o.root.length) o.root.remove();
                            $.event.trigger({
                                type: 'onDefferedCopyComplete',
                                contextContainer: o.selectors
                            });
                            console.log('Copy done');
                        });
                    }
                } catch (e) {
                    o.process.fail(function (){
                        console.log('Deffered copy error!')
                    });
                    return false;
                }
            }
        };

        /**
         * Устанавливает новый заголовок формы, читает динамический заголовок из дата-атрибута data-title.
         * Его формат: "Текст_заголовка:class". Класс указывать без точки
         * @param toItem
         */
        DeferredDataMng.prototype.setNewTitle = function (toItem) {
            var itemTitle = toItem.data('title');
            if (typeof itemTitle !== 'undefined') {
                var arTitle = itemTitle.split(':');
                toItem.find('.' + arTitle[1]).text(arTitle[0]);
            }
        }

        /**
         * Обратный вызов для заданных классов и ID
         * @param callback
         */
        DeferredDataMng.prototype.onDeferElements = function(callback) {
            var o = this;
            o.root.children().each(function () {
                var item = $(this);
                var toID = item.attr('to'); //Читаем их атрибуты (в нашем случае класс)
                var foundIDs = $('#' + toID);
                var foundClasses = $('.' + toID);


                if (typeof toID == 'undefined') { //Если забыли прописать - назначаем значение по умолчанию
                    toID = item.data('to-deffered');
                }

                    if (typeof toID != 'string' || toID.length == 0) { //Защита от дурака
                    return false;
                }

                o.items = o.items.add(item); //Создаем выборку форм на странице
                if(foundIDs.length || foundClasses.length) {
                    var deferredSelectors = $(foundIDs).add(foundClasses);
                    o.pendings = deferredSelectors;
                    o.selectors = deferredSelectors;
                   if(callback && typeof callback === 'function') {
                       callback(item, toID, deferredSelectors);
                   }
                }

            });

        };

        DeferredDataMng.prototype.init = function () {

            var o = this;
            o.onDeferElements(function(item, toID, deferredSelectors) {
                if (deferredSelectors.length) {
                    deferredSelectors.each(function () {
                        o.copy(item, $(this));
                    })
                }
            });

        }

        return DeferredDataMng;
    });
}
;
